export enum PlanActionStepStatus {
  NOT_STARTED = 0,
  UNDERSTAND = 1,
  DIALOG = 2,
  ACTION = 3,
  REVIEW = 4,
}

export enum ActionPlanStatus {
  NOT_STARTED = 0,
  IN_PROGRESS = 1,
  COMPLETED = 2,
}

export const ACTION_PLAN_STATUS_MAP = [
  {
    id: ActionPlanStatus.NOT_STARTED,
    name: 'NotStarted',
  },
  {
    id: ActionPlanStatus.IN_PROGRESS,
    name: 'InProgress',
  },
  {
    id: ActionPlanStatus.COMPLETED,
    name: 'Completed',
  },
];
Object.freeze(ACTION_PLAN_STATUS_MAP);
